import React, { FC, PropsWithChildren, useEffect } from 'react';

import * as Sentry from '@sentry/react';

import * as O from 'fp-ts/Option';
import { pipe } from 'fp-ts/function';
import { HttpError } from '@core/http';
import ErrorPage from '@shared/components/error-page/ErrorPage';
import { Profile } from '@modules/profile/model';

function getSentryUser(profile: O.Option<Profile>): Sentry.User {
  return pipe(
    profile,
    O.fold<Profile, Sentry.User>(
      () => ({ username: 'Not authenticated' }),
      p => ({
        role: p.role,
      }),
    ),
  );
}

interface SentryProviderProps {
  profile: O.Option<Profile>;
}

const SentryProvider: FC<PropsWithChildren<SentryProviderProps>> = ({ profile, children }) => {
  useEffect(() => {
    Sentry.configureScope(scope => {
      scope.setUser(getSentryUser(profile));
    });
  }, [profile]);

  return <Sentry.ErrorBoundary fallback={<ErrorPage error={HttpError.default} />}>{children}</Sentry.ErrorBoundary>;
};

export default SentryProvider;
